import {
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { ListItemSkeletonComponent } from '@shared/components/skeletons/list-item-skeleton.component';
import { StatusMessageComponent } from '@shared/components/status-message/status-message.component';
import { NotificationsStore } from './notifications.store';
import { NotificationItemComponent } from './notification-item.component';
import { NotificationNavigationService } from '@core/services/notification-navigation.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule,
    TranslatePipe,
    ListItemSkeletonComponent,
    StatusMessageComponent,
    NotificationItemComponent,
  ],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsComponent {
  protected readonly store = inject(NotificationsStore);
  private readonly navigationService = inject(NotificationNavigationService);

  protected trackByNotificationId = (_: number, notification: { notificationId: string }): string => {
    return notification.notificationId;
  };

  protected handleMarkRead(notificationId: string): void {
    this.store.markRead(notificationId);
  }

  protected onNavigate(notificationId: string): void {
    const notification = this.store
      .notifications()
      .find((item) => item.notificationId === notificationId);

    this.navigationService.navigateToNotification(notification);
  }
}
